import { Container } from '../../odie';

import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { getMatch2AssetPath } from '../util/assets';

/*
    petal falling animation
*/
export class FallingPetalAnimation extends Container implements IAnimation {
  // init
  //-------------------------------------------------------------------------
  constructor() {
    super();
  }

  public static assets(): string[] {
    return ['fx.pond/fx.pond.lotus.petal.png'];
  }

  // impl
  //-------------------------------------------------------------------------
  public async start(): Promise<void> {
    // create petal emitter
    const petalEmitter = this._createPetalEmitter();

    // animate petal
    await this._animatePetal(petalEmitter);
  }

  public stop() {}

  // private: animators
  //-------------------------------------------------------------------------
  private async _animatePetal(petal: ParticleEmitter) {
    // spawn petal
    this.addChild(petal.view);

    // start
    await petal.start();

    // despawn petal
    this.removeChild(petal.view);
  }

  // private: factory
  //-------------------------------------------------------------------------
  private _createPetalEmitter(): ParticleEmitter {
    return app.particles.create({
      textures: FallingPetalAnimation.assets().map((path) =>
        getMatch2AssetPath(path),
      ),
      rate: 0,
      limit: 3,
      emitterDuration: 0,
      duration: 2.5,
      velocity: { x: 0, y: -200 },
      angularVelocity: [0, Math.PI * 2],
      scale: [
        { x: 0.5, y: 0.5 },
        { x: 0.8, y: 0.8 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [60, 180] },
        { type: 'gravity', gravity: { x: 0, y: 700 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });
  }
}
